import React from "react";
import moment from "moment";
import DateInput from "../../../../parts/inputs/date-input";

const dateFormat = {
  normal: "YYYY-MM-DD",
  calendar: "MMM D, YYYY",
  utc: "YYYYMMDD",
};

const getSelectorsOptions = ({ quickDisabled, type, value }) => [
  {
    key: "2weeks",
    text: "2 weeks",
    value: 2,
    type: "weeks",
    active: !quickDisabled && type === "weeks" && value === 2,
  },
  {
    key: "1month",
    text: "1 month",
    value: 1,
    type: "months",
    active: !quickDisabled && type === "months" && value === 1,
  },
  {
    key: "3month",
    text: "3 month",
    value: 3,
    type: "months",
    active: !quickDisabled && type === "months" && value === 3,
  },
  {
    key: "6month",
    text: "6 month",
    value: 6,
    type: "months",
    active: !quickDisabled && type === "months" && value === 6,
  },
  {
    key: "lifetime",
    text: "Lifetime",
    value: 1,
    type: "lifetime",
    active: !quickDisabled && type === "lifetime",
  },
];

const Selector = ({
  text = "",
  type,
  value,
  active = false,
  getDateFirstEntry,
  dateTo,
  updateState,
}) => (
  <button
    data-button-type={active ? "primary" : "secondary"}
    onClick={() => {
      if (type === "lifetime") {
        updateState({
          rangeSelector: {
            type,
            value,
          },
          quickDisabled: false,
          dateTo: null,
          dateFrom: moment(getDateFirstEntry()).format(dateFormat.calendar),
        });
        return;
      }
      const formatedDateTo = (
        dateTo
          ? moment(dateTo, dateFormat.calendar)
          : moment(new Date(), dateFormat.normal)
      )
        .subtract(value, type)
        .format(dateFormat.calendar);
      updateState({
        dateFrom: formatedDateTo,
        dateTo,
        quickDisabled: false,
        rangeSelector: {
          type,
          value,
        },
      });
    }}
  >
    {text}
  </button>
);

const RangeSelector = ({
  dateTo,
  rangeSelector,
  quickDisabled,
  updateState,
  getDateFirstEntry,
}) => {
  const { value, type } = rangeSelector;
  const selectors = getSelectorsOptions({ quickDisabled, type, value });

  return (
    <div className="selector-container">
      {selectors.map(({ text, type, value, active }) => (
        <Selector
          text={text}
          type={type}
          value={value}
          active={active}
          getDateFirstEntry={getDateFirstEntry}
          dateTo={dateTo}
          updateState={updateState}
        />
      ))}
    </div>
  );
};

const RangeContainerComponent = ({
  dateTo,
  dateFrom,
  rangeSelector,
  quickDisabled,
  updateState,
  getDateFirstEntry,
}) => {
  const handleDateChange = (date, type = "dateFrom") => {
    let arg = {
      [type]: date,
      quickDisabled: true,
    };

    if (type === "dateTo" && moment(date).isBefore(dateFrom || new Date())) {
      // If dateTo is before than dateFrom, update dateFrom
      arg = Object.assign({}, arg, {
        dateFrom: date,
      });
    }

    if (type === "dateFrom" && !dateTo) {
      arg = Object.assign({}, arg, {
        dateTo: moment(new Date()).format(dateFormat.calendar),
      });
    }

    updateState(arg);
  };

  return (
    <section role="date-range-container">
      <div role="calendar-date-selectors">
        <DateInput
          name="from"
          placeholder="Start Date"
          value={dateFrom || new Date()}
          max={dateTo || new Date()}
          onChange={(date) => handleDateChange(date, "dateFrom")}
        />
        <span>to</span>
        <DateInput
          name="to"
          placeholder="End Date"
          value={dateTo || new Date()}
          max={new Date()}
          onChange={(date) => handleDateChange(date, "dateTo")}
        />
      </div>
      <RangeSelector
        dateTo={dateTo}
        rangeSelector={rangeSelector}
        quickDisabled={quickDisabled}
        updateState={updateState}
        getDateFirstEntry={getDateFirstEntry}
      />
    </section>
  );
};
export default RangeContainerComponent;
